import { DigitalFarmerAccount } from '../../azure-b2c/storage'
import { StockAvailabilityCodes } from '../../products/components/StockAvailability/StockAvailabilityStatus'
import { Product, StockAvailabilityType } from '../../products/storage'
import { CartDeliveryMode, CartObject } from '../storage/cart.types'

export const getUrgentDeliveryUnavailable = ({
  cart,
  productId,
  stockAvailabilities,
  homeBranchId,
}: {
  cart: CartObject
  productId: number
  stockAvailabilities: StockAvailabilityType[] | undefined
  homeBranchId: string
}): boolean => {
  if (!stockAvailabilities) return false
  if (
    cart.cartDeliveryMode === CartDeliveryMode.DELIVERY &&
    cart.deliveryDetails?.urgent === true &&
    stockAvailabilities?.find(
      (x) => x.productId === productId && x.inventLocationId === `265-${homeBranchId}`,
    )?.inventoryLevelCode === StockAvailabilityCodes.OUT_OF_STOCK
  )
    return true
  return false
}

export const hasUrgentDeliveryUnavailable = ({
  cart,
  items,
  account,
}: {
  cart: CartObject
  items: Product[]
  account: DigitalFarmerAccount
}) => {
  return items.some((item) =>
    getUrgentDeliveryUnavailable({
      cart,
      productId: item.productId,
      stockAvailabilities: item.stockAvailabilities,
      homeBranchId: account.homeBranchId,
    }),
  )
}
